import { render, staticRenderFns } from "./dxtg.vue?vue&type=template&id=5b7c83e1&scoped=true"
import script from "./dxtg.vue?vue&type=script&lang=js"
export * from "./dxtg.vue?vue&type=script&lang=js"
import style0 from "./dxtg.vue?vue&type=style&index=0&id=5b7c83e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c83e1",
  null
  
)

export default component.exports